import React, { useState, useEffect } from "react";
import RatingGame from "../../components/RatingGameSpelling";
import useGame from "../../hooks/useGame";
import { navigate } from "@reach/router";
import LoadingScreen from "../../components/LoadingScreen";
import Papa from "papaparse";

export default function Rating({ ...props }) {
    const game = useGame(props.game.id);
    const [localQuestions, setLocalQuestions] = useState(null);

    useEffect(() => {
        Papa.parse("/questions/spelling_rating.csv", {
            download: true,
            header: true,
            skipEmptyLines: true,
            complete: function (results) {
                const groupedByDifficulty = {};
                
                // Get the Year(s) selected in the practice menu
                const targetYears = Array.isArray(props.topics) 
                    ? props.topics.map(y => y.toString().trim()) 
                    : (props.topics ? [props.topics.toString().trim()] : []);

                results.data.forEach(row => {
                    const rowYear = row['Category']?.toString().trim();
                    const rowDiff = row['Difficulty']?.toString().trim();

                    // 1. FILTER: Only keep words from the selected Year Group(s)
                    if (targetYears.length > 0 && !targetYears.includes(rowYear)) return;

                    // 2. GROUP: Use the 'Difficulty' column (1-10+) for the levels
                    if (!groupedByDifficulty[rowDiff]) groupedByDifficulty[rowDiff] = [];

                    groupedByDifficulty[rowDiff].push({
                        question: row['Example sentence'], // Matches Rating.js original map
                        sentence: row['Example sentence'],
                        audio: row['Word'], 
                        word: row['Word'],
                        topic_id: rowYear,
                        difficulty: rowDiff // Store the actual difficulty level
                    });
                });

                // 3. SORT: Ensure level 1 comes before level 2, etc.
                const sortedDiffs = Object.keys(groupedByDifficulty).sort((a, b) => Number(a) - Number(b));

                if (sortedDiffs.length > 0) {
                    const finalData = sortedDiffs.map(diff => {
                        // Shuffle words within each difficulty level
                        return groupedByDifficulty[diff].sort(() => Math.random() - 0.5);
                    });
                    
                    console.log("CSV Loaded. Levels found:", sortedDiffs);
                    setLocalQuestions(finalData);
                }
            }
        });
    }, [props.topics]);

    return localQuestions ? (
        <RatingGame
            questionslist={localQuestions}
            playAudio={true}
            onBack={() => {
                navigate(`/games/${game.id}`);
            }}
            game={game}
            topics={props.topics}
            endless={props.endless}
            initialLevel={props.initialLevel}
        />
    ) : (
        <LoadingScreen />
    );
}